import { createTheme } from "@mui/material/styles";

/** Aligns public pages with Dashboard chrome (emerald accent, gray neutrals). */
export const dashboardAppTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#10b981",
      dark: "#059669",
      light: "#34d399",
    },
    secondary: {
      main: "#374151",
    },
    background: {
      default: "#f9fafb",
      paper: "#ffffff",
    },
    text: {
      primary: "#111827",
      secondary: "#6b7280",
    },
    divider: "#e5e7eb",
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    h4: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
      color: "#111827",
    },
    h6: {
      fontWeight: 600,
      color: "#111827",
    },
    subtitle1: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
          fontWeight: 600,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
  },
});
